import pick from 'lodash/pick';
import * as relatedClient from 'lib/clients/searchRelatedPropertyAvailability';
import * as actions from 'store/recommendedProperty/recommendedPropertyActions';
import { apiRequestFailure } from 'store/error/errorActions';
import { getPropertyId } from 'store/property/propertySelectors';
import { createAsyncLogic } from 'lib/logic';
import { getFullKnownQuery } from 'store/router/routerSelectors';

export const fetchRecommendedPropertiesLogic = createAsyncLogic({
  type: actions.fetchRecommendedPropertyAvailability,
  latest: true,
  async process({ getState }, dispatch) {
    const state = getState();
    const query = getFullKnownQuery(state);
    const checkIn = query.checkIn;
    const checkOut = query.checkOut;

    if (checkIn && checkOut) {
      const buildParams = (params) => pick(params, ['propertyId', 'adults', 'children', 'infants', 'payWith', 'checkIn', 'checkOut']);
      const client = relatedClient.searchRelatedPropertyAvailability;

      if (!client) {
        throw new Error('Invalid treatment, should be related_properties');
      }

      dispatch(actions.setLoading(true));

      const propertyId = getPropertyId(state);
      const params = buildParams({ ...query, propertyId });

      const { results } = await client(params);
      dispatch(actions.fetchRecommendedPropertyAvailabilitySuccess(results));
    }
  },
  onError({ parsedError }, dispatch) {
    dispatch(actions.fetchRecommendedPropertyAvailabilityFailure(parsedError));
    dispatch(apiRequestFailure(parsedError));
  },
  onFinally(context, dispatch) {
    dispatch(actions.setLoading(false));
  },
});
